// assets/pg.js
(function(){
  function init(root){
    const track = root.querySelector('.pg__track');
    const slides = Array.from(root.querySelectorAll('.pg__img'));
    const prev = root.querySelector('[data-prev]');
    const next = root.querySelector('[data-next]');
    const dotsBox = root.querySelector('[data-dots]');
    let i = 0;

    if (!track || slides.length < 2){
      prev?.remove(); next?.remove(); dotsBox?.remove();
      return;
    }

    // build dots
    const dots = slides.map((_,idx)=>{
      const b=document.createElement('button');
      b.addEventListener('click',()=>go(idx));
      dotsBox.appendChild(b); return b;
    });

    function go(n){
      i = (n+slides.length)%slides.length;
      track.style.transform = `translateX(${-100*i}%)`;
      dots.forEach((d,j)=>d.classList.toggle('is-active', j===i));
    }
    prev.addEventListener('click',()=>go(i-1));
    next.addEventListener('click',()=>go(i+1));

    // simple touch swipe
    let sx=0, dx=0, dragging=false, vp=root;
    vp.addEventListener('touchstart',e=>{dragging=true; sx=e.touches[0].clientX;},{passive:true});
    vp.addEventListener('touchmove',e=>{if(dragging) dx=e.touches[0].clientX-sx;},{passive:true});
    vp.addEventListener('touchend',()=>{ if(!dragging) return; if(dx>40) go(i-1); else if(dx<-40) go(i+1); drag=false; dx=0; });

    go(0);
  }

  function boot(){
    document.querySelectorAll('[data-card-gallery]').forEach(init);
  }
  document.readyState==='loading'?document.addEventListener('DOMContentLoaded',boot):boot();
})();
